
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/theme/[slug]",
      function () {
        return require("private-next-pages/theme/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/theme/[slug]"])
      });
    }
  